// Reservefahrzeuge (deaktivierte Fahrzeuge).
//
// Ein Fahrzeug mit `active === false` ist vorübergehend außer Dienst — z. B. ein
// Ersatzwagen, der nur einspringt, wenn ein anderes Auto defekt ist. Es bleibt
// angelegt, zählt aber nicht gegen das Fahrzeugkontingent bzw. den
// Lizenzrahmen, ist in der Fahrer-App nicht wählbar und fließt nicht in die
// Fahrzeugtypen/Spezialfähigkeiten der Bestellmasken ein.
//
// Umschalten läuft ausschließlich über die CF `setVehicleActive` (Kontingent-
// prüfung beim Aktivieren); die Firestore-Rules sperren das Feld für Clients.
// Konzept: nextcab_mobile/docs/general/reservefahrzeuge.md

/**
 * True, wenn das Fahrzeug aktiv ist. Bewusst auf `!== false` geprüft:
 * Bestandsfahrzeuge ohne das Feld gelten als aktiv.
 * @param {object} vehicle
 * @returns {boolean}
 */
export const isVehicleActive = (vehicle) => vehicle?.active !== false;

/**
 * Nur aktive Fahrzeuge einer Liste.
 * @param {Array<object>|null|undefined} vehicles
 * @returns {Array<object>}
 */
export const activeVehiclesOnly = (vehicles) => (vehicles || []).filter(isVehicleActive);
